import {di} from "@dp-instant/core";
import {FighterView} from "@game/coregame/view/FighterView";
import {TypesGame} from "@game/TypesGame";
import {PathHolder} from "../ecs/components/PathHolder";
import {Building} from "../ecs/entities/Building";
import {Fighter} from "../ecs/entities/Fighter";
import {FighterGroupsSystem} from "../ecs/systems/FighterGroupSystem";
import {math} from "../helpers";
import {PlayerType} from "../interfaces/PlayerType";
import {Vector2} from "../interfaces/Vector2";
import {GameModel} from "../model/GameModel";
import {Spawner} from "./Spawner";
import {SpritesPool} from "@game/coregame/utils/SpritesPool";
import {Graphics, Sprite, utils} from "pixi.js-legacy";
import {color} from "@game/coregame/helpers";
import {CachedGraphics} from "@game/coregame/interfaces/CachedGraphics";
import {SkinManager} from "../managers/SkinManager";

export class FighterGroup {
    public Amount: int = 0;
    public StartTimestamp: float = 0;

    public get BurstWidth(): float {
        return this.Source.get(PathHolder)!.getPathWidth();
    }
    public get BurstDelay() {
        return this.Source.get(Spawner)!.burstDelay;
    }

    public constructor(
        private readonly id: int,
        public readonly Path: Vector2[],
        public readonly Speed: float,
        public readonly Owner: PlayerType,
        public readonly Target: Building,
        public readonly Source: Building
    ) {
        this.StartTimestamp = Date.now();
    }

    public GetPathLen(): float {
        let distance = 0;
        for (let i = 1; i < this.Path.length; i++) {
            distance += math.dist(this.Path[i - 1], this.Path[i]);
        }

        return distance;
    }

    protected initUnitGraphics(fighter: Fighter): Sprite {
        const skinManager: SkinManager = di.get<SkinManager>(TypesGame.skinManager);
        const spritesPool: SpritesPool = di.get(TypesGame.spritesPool);
        const textureUrl = skinManager.getFighterTextureBy(fighter.owner);
        const size = Fighter.DEFAULT_SIZE * fighter.scaleFactor * 1.5; // todo move to constant
        const sprite = spritesPool.fromDisplayObject(textureUrl, () => {
            const sprite = new Sprite(utils.TextureCache[textureUrl]);
            const bounds = sprite.getBounds();
            sprite.anchor.set(0.5);
            sprite.scale.set(size / Math.max(bounds.height, bounds.width));
            return sprite;
        });
        sprite.tint = color.fromHex(skinManager.getColorBy(fighter.owner)[1]);
        return sprite;
    }

    public AddFighter(fighter: Fighter) {
        this.Amount++;
        this.StartTimestamp = Date.now();

        const model: GameModel = di.get(TypesGame.model);
        const view = new FighterView();
        const unitAsset = this.initUnitGraphics(fighter);
        unitAsset.anchor.set(0.5);
        view.addChild(unitAsset);

        fighter.add(view);
        model.engine.addEntity(fighter);
        fighter.group = this;
    }

    public Check(): void {
        if (
            ((Date.now() - this.StartTimestamp) * this.Speed) / this.GetPathLen() >= 1 &&
            this.Amount <= 0
        ) {
            FighterGroupsSystem.RemoveGroup(this.id);
        }
    }

    OnFighterDied(): void {
        this.Amount--;
    }
}
